
import type { Result } from '@empathybroker/tsclient-play/dist/models/search/result'
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

import { PositionEnum } from '../../enums'

import EpbAside from '../aside.component.vue'
import FadingScroll from '../fading-scroll.component.vue'
import { EpbButton } from '../shared/epb-button'

import ExplainAsideResultCard from './explain-results-aside-result-card.component.vue'
import ExplainResultsTable from './explain-results-table.component.vue'

export default defineComponent({
  name: 'EpbExplainResultsAside',
  components: {
    EpbAside,
    EpbButton,
    FadingScroll,
    ExplainAsideResultCard,
    ExplainResultsTable,
  },
  props: {
    results: {
      type: Array as PropType<Array<Result>>,
      required: true,
    },
    query: {
      type: String as PropType<string>,
      required: true,
    },
    collapsed: Boolean,
  },
  data() {
    return {
      initialAnimationDurationInMillis: 2000,
      messages: this.$epb.messages.explain,
      PositionEnum,
    }
  },
  methods: {
    onClearSelectionClick(): void {
      this.$emit(
        'removeResults',
        this.results.map((result: Result) => result.id),
      )
    },
  },
})
